import { useContext, useEffect } from "react";
import { useTrackingPixels } from "../../hooks/useTrackingPixels";
import { CheckoutContext } from "../../contexts/CheckoutContext";
import useKwaiPixels from "../../hooks/useKwaiPixels";


export default function KwaiPixels (){
    const trackingPixels = useTrackingPixels();
    const { offer } = useContext(CheckoutContext);
    const { onCheckoutVisit } = useKwaiPixels()
   
    useEffect(() => {
        const initializePixel = () => {
            // @ts-ignore
            if (window.kwaiq && typeof window.kwaiq.load === 'function') {
                trackingPixels.kwai_pixels.forEach(pixel => {
                    // @ts-ignore
                    window.kwaiq.load(pixel.pixelId);
                })
            } else {
                console.error('Kwai Pixel script loaded but `kwaiq` is not available or does not have `load` function');
            }
        };

        // Wait for the script to load
        const checkScript = setInterval(() => {
             // @ts-ignore
            if (window.kwaiq) {
            clearInterval(checkScript);
            initializePixel();
                if(offer){
                    onCheckoutVisit()
                }
            }
        }, 100); // Check every 100ms

        return () => {
            clearInterval(checkScript);
        };
       
    }, [trackingPixels]);
      
      return null
}